import { render, staticRenderFns } from "./actions.vue?vue&type=template&id=c604d80c&scoped=true"
import script from "./actions.vue?vue&type=script&lang=js"
export * from "./actions.vue?vue&type=script&lang=js"
import style0 from "./actions.vue?vue&type=style&index=0&id=c604d80c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c604d80c",
  null
  
)

export default component.exports